import { createApp, configureCompat } from 'vue'
import "../lib/_jquery.js"
import * as UILibrary from "@assemblyvoting/ui-library"; // Imports components
import "@assemblyvoting/ui-library/styles"; // Imports styles

// Components
import RevealableInfo from "../components/shared/RevealableInfo.vue"
import ImporterProgressBar from "../components/backend/ImporterProgressBar.vue";
import ContestImporterProgressBar from "@/components/backend/ContestImporterProgressBar.vue";
import ImageSelector from "../components/backend/ImageSelector.vue";
import CampaignTemplateSelector from "../components/backend/CampaignTemplateSelector.vue"
import CampaignControls from "../components/backend/CampaignControls.vue"
import Live from "../components/backend/Live.vue";
import ExclusiveInputs from "../components/backend/ExclusiveInputs.vue"
import VoterSecrets from "../components/backend/VoterSecrets.vue"
import VoterFormSecrets from "../components/backend/VoterFormSecrets.vue"
import TranslationsEditor from "../components/backend/TranslationsEditor.vue"
import MessageLocalContent from "../components/backend/messages/MessageLocalContent.vue";
import AllowedDomains from "../components/backend/election_config/access/AllowedDomains.vue";
import StatisticsSegments from "../components/backend/election_config/statistics/StatisticsSegments.vue";
import Result from '../components/frontend/shared/Result.vue';
import BoardProgressBar from '../components/backend/BoardProgressBar.vue';
import ContestSelectionList from "@/components/backend/ContestSelectionList.vue";
import BallotPreview from "@/components/backend/BallotPreview.vue";
import PresentationPreview from "@/components/backend/PresentationPreview.vue";
import ElectionCopierProgress from "@/components/backend/ElectionCopierProgress.vue";


import i18n from "./shared/i18n";
import store from './frontend/store';

// Needs to be "called" here to instantiate methods for hover tooltips
import bsTooltip from './shared/bs-tooltips';
import VotingRoundReportProgress from '../components/backend/VotingRoundReportProgress.vue';

// Hide warnings coming from the actioncable-vue module.
configureCompat({
  OPTIONS_BEFORE_DESTROY: 'suppress-warning',
  CUSTOM_DIR: 'suppress-warning',
  ATTR_FALSE_VALUE: 'suppress-warning',
});

const SimpleComponents = {
  'revealable-info': RevealableInfo,
  'importer-progress-bar': ImporterProgressBar,
  'contest-importer-progress-bar': ContestImporterProgressBar,
  'image-selector': ImageSelector,
  'campaign-template-selector': CampaignTemplateSelector,
  'campaign-controls': CampaignControls,
  'exclusive-inputs': ExclusiveInputs,
  'voter-secrets': VoterSecrets,
  'voter-form-secrets': VoterFormSecrets,
  'translations-editor': TranslationsEditor,
  'message-local-content': MessageLocalContent,
  'allowed-domains': AllowedDomains,
  'statistics-segments': StatisticsSegments,
  'result': Result,
  'board-progress-bar': BoardProgressBar,
  'contest-selection-list': ContestSelectionList,
  'ballot-preview': BallotPreview,
  'presentation-preview': PresentationPreview,
  'voting-round-report-progress': VotingRoundReportProgress,
  'election-copier-progress': ElectionCopierProgress,
}

$(function(){
  Object.entries(SimpleComponents).forEach(([tag, component]) => {
    $(`[data-vue-component=${tag}]`).each(function(){
      let propsData = $(this).data('vue-props')
      let app = createApp(component, propsData)
      app.use(i18n)
      app.use(UILibrary.default, i18n)
      app.mount(this)
    })
  })

  $('[data-vue-component="live"]').each(async function(){
    let election = JSON.parse(this.getAttribute('data-election'))
    let electionUrl = this.getAttribute('data-url')
    let electionLocales = JSON.parse(this.getAttribute('data-locales'))
    let readonly = this.getAttribute('data-readonly') === "true"

    window.onunhandledrejection = event => {
      let error = event.reason;
      if(!error.response){
        // display connection warning
        store.commit('connectionFailed')
        event.preventDefault()
      } else if(error.response.status === 401 && [11].includes(error.response.data.code)) { // [11: invalidAuthenticityToken]
        // the admin's authenticity token has expired (likely because their session has expired)
        if(confirm(i18n.$t('js.backend.live.invalid_authenticity_token_confirm_reload'))){
          window.location.reload()
        }
        event.preventDefault()
      } else if(error.response.status === 403) {
        store.commit('showToast', {header: i18n.t('js.toasts.error.request_denied'), body: error.response.data.message, duration: 5, classes: {header: 'bg-danger text-white'}})
        event.preventDefault()
      }
    }

    store.commit('setElectionUrl', { electionUrl })
    store.commit('setSlides', [])
    store.commit('setLocales', electionLocales)
    store.commit('setElection', {...election, userModules: {}});
    store.commit('setReadonly', readonly)
    let app = createApp(Live)

    app.use(store)
    app.use(i18n)
    app.use(UILibrary.default, i18n)
    app.mount('[data-vue-component="live"]')
  })
})

$(function(){
  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // We listen to the resize event
  window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });
})
